export const serviceAssignmentRoutes = {
  SERVICE_OFFER: ":serviceOfferId",
  ACCEPTANCE: "accept",
  CHOOSE_PLAN: "chooseSubscriptionPaymentPlan",
  CHOOSE_FORMULA: "chooseFormula",
  CHOOSE_PAYMENT_METHOD: "choosePreferredPaymentMethod",
  CONFIGURE_PAYMENT_METHOD: "configurePreferredPaymentMethod",
  NEW_SUBSCRIPTION_PAYMENT: ":serviceOfferId/subscription_payment/new",
  PAYMENT_METHOD_CONFIGURATION: "paymentMethodConfiguration",
  LEGACY_SERVICE_OFFER_FLOWS_CONFIRMATION_PAGE: "comments/new",
};
